// extracted by mini-css-extract-plugin
export var fullWidthButton = "_qb-0";